/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_MyAbsenceResponse = {
    absence_type?: string;
    /**
     * Self-reported ACCIDENT only: day of the accident (YYYY-MM-DD)
     */
    accident_date?: string;
    /**
     * true when the office acknowledged the report (who acknowledged is not projected)
     */
    acknowledged: boolean;
    approval_status?: string;
    approved_at?: string;
    /**
     * Reason the office gave when it cancelled the report
     */
    cancel_reason?: string;
    /**
     * Doctor's certificate state: NOT_DUE, DUE, PROVIDED, EAU_RETRIEVED, or NOT_REQUIRED
     */
    certificate_status: employee_selfservice_MyAbsenceResponse.certificate_status;
    created_at?: string;
    employee_id?: string;
    /**
     * The employee went home at this time on the first day (HH:MM)
     */
    first_day_from_time?: string;
    from_date?: string;
    from_time?: string;
    full_day?: boolean;
    id?: string;
    /**
     * true when the employee reported the absence (SICK, ACCIDENT, CHILD_SICK)
     */
    is_self_report: boolean;
    notes?: string;
    /**
     * true when the report overlaps a vacation absence
     */
    overlaps_vacation: boolean;
    rejection_reason?: string;
    to_date?: string;
    to_time?: string;
    /**
     * Self-reported ACCIDENT only: the accident happened at work or on the way to work
     */
    work_related?: boolean;
};
export namespace employee_selfservice_MyAbsenceResponse {
    /**
     * Doctor's certificate state: NOT_DUE, DUE, PROVIDED, EAU_RETRIEVED, or NOT_REQUIRED
     */
    export enum certificate_status {
        NOT_DUE = 'NOT_DUE',
        DUE = 'DUE',
        PROVIDED = 'PROVIDED',
        EAU_RETRIEVED = 'EAU_RETRIEVED',
        NOT_REQUIRED = 'NOT_REQUIRED',
    }
}

